<template>
  <v-dialog v-model="visible" max-width="800px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12" lg="6">
              <v-select
                v-model="unidadNegocioSeleccionadaId"
                :items="unidadesNegocios"
                item-text="nombre"
                item-value="id"
                label="Unidad de Negocio"
                required
                outlined
                dense
                hide-details
                clearable
                @change="form.categoriaId = null"></v-select>
            </v-col>

            <v-col cols="12" lg="6">
              <v-select
                v-model="form.categoriaId"
                :items="categoriasFiltradas"
                item-text="nombre"
                item-value="id"
                label="Categorías"
                :disabled="unidadesNegocios.length === 0 || !unidadNegocioSeleccionadaId"
                required
                outlined
                dense
                hide-details
                clearable>
                <template #item="{ item }">
                  <v-list>
                    <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ unidadesNegocios.find((unidadNegocio) => unidadNegocio.id == item.unidadNegocioId)?.nombre }}
                    </v-list-item-subtitle>
                  </v-list>
                </template>
              </v-select>

              <small v-for="error in errores.categoriaId" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="6">
              <v-select
                v-model="form.moneda"
                :items="monedasOpciones"
                label="Moneda"
                required
                outlined
                dense
                hide-details
                clearable></v-select>
            </v-col>

            <v-col cols="12" lg="6">
              <v-autocomplete
                v-model="form.nombrePlanCobroPrograma"
                :items="nombresPlanesCobroPrograma"
                :search-input.sync="busquedaPlanCobroPrograma"
                :loading="cargandoPlanesCobroPrograma"
                label="Nombre Plan Cobro Programa (opcional)"
                no-filter
                outlined
                dense
                hide-details
                clearable></v-autocomplete>

              <small v-for="error in errores.nombrePlanCobroPrograma" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="6">
              <v-text-field
                v-model="form.montoComisionPlanContado"
                :label="`Monto Comisión Plan Contado${textoMoneda} (opcional)`"
                type="number"
                min="1"
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.montoComisionPlanContado" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="6">
              <v-checkbox
                v-model="form.esAMonto"
                label="Es relativo al monto del programa"
                hide-details
                @change="
                  () => {
                    form.desde = null;
                    form.hasta = null;
                    form.monto = null;
                  }
                "></v-checkbox>
            </v-col>

            <template v-if="!form.esAMonto">
              <v-col cols="12" lg="4">
                <v-text-field
                  v-model="form.desde"
                  :label="`Desde${textoMoneda}`"
                  type="number"
                  min="1"
                  :disabled="form.esAMonto"
                  required
                  outlined
                  dense
                  hide-details
                  clearable></v-text-field>

                <small v-for="error in errores.desde" :key="error" class="d-block text-danger">
                  {{ error }}
                </small>
              </v-col>

              <v-col cols="12" lg="4">
                <v-text-field
                  v-model="form.hasta"
                  :label="`Hasta${textoMoneda}`"
                  type="number"
                  min="1"
                  :disabled="form.esAMonto"
                  outlined
                  dense
                  hide-details
                  clearable></v-text-field>

                <small v-for="error in errores.hasta" :key="error" class="d-block text-danger">
                  {{ error }}
                </small>
              </v-col>

              <v-col cols="12" lg="4">
                <v-text-field
                  v-model="form.monto"
                  :label="`Monto${textoMoneda}`"
                  type="number"
                  min="1"
                  :disabled="form.esAMonto"
                  required
                  outlined
                  dense
                  hide-details
                  clearable></v-text-field>

                <small v-for="error in errores.monto" :key="error" class="d-block text-danger">
                  {{ error }}
                </small>
              </v-col>
            </template>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" :disabled="guardando" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" :disabled="guardando" :loading="guardando" text @click.prevent="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../../mixins/modal-form.mixin';
import apiConsumerMixin from '../../mixins/api-consumer.mixin';
import CategoriasService from '../../services/categorias.service';
import { ACCIONES, MONEDAS_OPCIONES } from '../../utils/constantes';
import MontoComisionService from '../../services/montos-comisiones.service';
import unidadesNegociosService from '../../services/unidades-negocios.service';
import planCobrosProgramaService from '../../services/plan-cobros-programa.service';

export default {
  name: 'ModalFormularioMontosComisiones',
  mixins: [modalFormMixin, apiConsumerMixin],
  props: {
    institucionId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    'form.categoriaId': function () {
      this.errores.categoriaId = [];
    },
    'form.moneda': function () {
      this.errores.moneda = [];
    },
    'form.desde': function () {
      this.errores.desde = [];
    },
    'form.hasta': function () {
      this.errores.hasta = [];
    },
    'form.monto': function () {
      this.errores.monto = [];
    },
    'form.nombrePlanCobroPrograma': function () {
      this.errores.nombrePlanCobroPrograma = [];
    },
    'form.montoComisionPlanContado': function () {
      this.errores.montoComisionPlanContado = [];
    },
    busquedaPlanCobroPrograma() {
      this.buscarPlanesCobroPrograma();
    },
  },
  computed: {
    categoriasFiltradas() {
      return this.categorias.filter((categoria) => categoria.unidadNegocioId == this.unidadNegocioSeleccionadaId);
    },
    textoMoneda() {
      return this.form.moneda ? ` (${this.form.moneda})` : '';
    },
  },
  data() {
    return {
      categorias: [],
      unidadesNegocios: [],
      unidadNegocioSeleccionadaId: null,
      monedasOpciones: MONEDAS_OPCIONES,
      nombresPlanesCobroPrograma: [],
      busquedaPlanCobroPrograma: null,
      retardoBusquedaPlanCobroPrograma: null,
      cargandoPlanesCobroPrograma: false,
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      this.unidadNegocioSeleccionadaId = null;

      this.nombresPlanesCobroPrograma = [];
      this.busquedaPlanCobroPrograma = null;

      return {
        id: null,
        institucionId: this.institucionId,
        institucion: null,
        categoriaId: null,
        categoria: null,
        moneda: null,
        esAMonto: false,
        desde: null,
        hasta: null,
        monto: null,
        nombrePlanCobroPrograma: null,
        montoComisionPlanContado: null,
      };
    },
    generarObjetoFormEditar(data) {
      this.unidadNegocioSeleccionadaId = data.categoria?.unidadNegocioId;
      this.nombresPlanesCobroPrograma = data.nombrePlanCobroPrograma ? [data.nombrePlanCobroPrograma] : [];
      this.busquedaPlanCobroPrograma = null;

      return {
        id: data.id,
        institucionId: data.institucionId,
        institucion: data.institucion,
        categoriaId: data.categoriaId,
        categoria: data.categoria,
        moneda: data.moneda,
        esAMonto: data.esAMonto,
        desde: data.desde,
        hasta: data.hasta || null,
        monto: data.monto,
        nombrePlanCobroPrograma: data.nombrePlanCobroPrograma || null,
        montoComisionPlanContado: data.montoComisionPlanContado,
      };
    },
    abrir(accion, data = []) {
      Promise.all([this.obtenerUnidadesNegocios(), this.obtenerCategorias()]).then(() => {
        this.abrirMixin(accion, data);
      });
    },
    cerrar() {
      this.cerrarMixin();
    },
    async obtenerCategorias() {
      await this.findAllMixin(
        CategoriasService.findAll,
        null,
        'CATEGORÍAS',
        () => {
          this.categorias = [];
        },
        null,
        (datos) => {
          this.categorias = datos;
        },
        () => {
          this.categorias = [];
        },
      );
    },
    async obtenerUnidadesNegocios() {
      await this.findAllMixin(
        unidadesNegociosService.findAll,
        null,
        'UNIDADES NEGOCIOS',
        () => {
          this.unidadesNegocios = [];
        },
        null,
        (datos) => {
          this.unidadesNegocios = datos;
        },
        () => {
          this.unidadesNegocios = [];
        },
      );
    },
    async obtenerPlanesCobroPrograma() {
      this.cargandoPlanesCobroPrograma = true;

      const params = {
        busqueda: this.busquedaPlanCobroPrograma,
        pagina: 1,
        itemsPorPagina: 50,
      };

      try {
        const response = await planCobrosProgramaService.findAllNombres({ params });
        const { datos = [] } = response?.data || {};

        this.nombresPlanesCobroPrograma = datos;
      } catch (error) {
        window.console.log(error);

        this.nombresPlanesCobroPrograma = [];
      } finally {
        this.cargandoPlanesCobroPrograma = false;
      }
    },
    buscarPlanesCobroPrograma() {
      if (!this.busquedaPlanCobroPrograma || this.form.nombrePlanCobroPrograma === this.busquedaPlanCobroPrograma) {
        return;
      }

      if (this.retardoBusquedaPlanCobroPrograma) {
        clearTimeout(this.retardoBusquedaPlanCobroPrograma);
      }

      this.retardoBusquedaPlanCobroPrograma = setTimeout(() => {
        this.obtenerPlanesCobroPrograma();
      }, 500);
    },
    async guardar() {
      if (this.guardando) {
        return;
      }

      const accion = this.form?.id ? ACCIONES.EDITAR : ACCIONES.REGISTRAR;
      const fnServicio = this.form?.id ? MontoComisionService.update : MontoComisionService.create;

      await this.saveMixin(
        accion,
        fnServicio,
        {
          ...this.form,
          hasta: this.form.hasta || null,
          nombrePlanCobroPrograma: this.form.nombrePlanCobroPrograma || null,
          montoComisionPlanContado: this.form.montoComisionPlanContado || null,
        },
        null,
        'MONTOS DE COMISIÓN',
        () => {
          this.guardando = true;
          this.errores = [];
        },
        () => {
          this.guardando = false;
        },
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          if (typeof errores === 'object') {
            this.errores = errores;
          }
        },
      );
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
</style>